import React from 'react'
import LazyLoad from 'react-lazyload'
import Jimmy from "../finalistsheadshot/jimmy.webp"
import admit from "../finalistsheadshot/amit.webp"
import Ethan from "../finalistsheadshot/gt.webp"
import Jaansi from "../finalistsheadshot/pe.webp"
import Trashgim from "../finalistsheadshot/go.png"
import Sakethram from "../finalistsheadshot/wid.png"
import Edward from "../finalistsheadshot/cm.webp"
import Narendran from "../finalistsheadshot/sik.webp"
import Nguyen from "../finalistsheadshot/naugh.webp"
import Vishnu from "../finalistsheadshot/iad.webp"
import Ameya from "../finalistsheadshot/id.webp"
import Antara from "../finalistsheadshot/uil.webp"
import Ruuhan from "../finalistsheadshot/ruhan.png"

const finalists = [
  { id: 1, name: 'Trashgim Mulosmani', image: Trashgim },
  { id: 2, name: 'Jaansi Patel', image: Jaansi },
  { id: 3, name: 'Ethan Sullivan', image: Ethan },
  { id: 4, name: 'Sakethram Ramakrishnan', image: Sakethram },
  { id: 5, name: 'Edward Kang', image: Edward },
  { id: 6, name: 'Narendran Karikkathil', image: Narendran },
  { id: 7, name: 'Amit Bhatt', image: admit },
  { id: 8, name: 'Nguyen Hai Phong', image: Nguyen },
  { id: 9, name: 'Vishnu Mangipudi', image: Vishnu },
  { id: 10, name: 'Ameya Shirguppe', image: Ameya },
  { id: 11, name: 'Antara Chhabra', image: Antara },
  { id: 12, name: 'Justin Yuan', image: Jimmy },
  { id: 13, name: 'Ruuhan Anand', image: Ruuhan },
  { id: 14, name: 'Anisha Pandey', image: null },
  { id: 15, name: 'Elaab Tsegaye', image: null },
]

// Finalist card component
const FinalistCard = ({ image, name }) => (
  <div style={{
    background: '#fff',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e8eef3',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 77, 153, 0.1)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.06)';
  }}>
    <div style={{
      position: 'relative',
      paddingTop: '120%',
      backgroundColor: '#f8f9fa'
    }}>
      {image ? (
        <LazyLoad once offset={100}>
          <img
            src={image}
            alt={name}
            className="no-invert-image-partners-css"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </LazyLoad>
      ) : (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#e8eef3',
          color: '#004d99',
          fontSize: '3rem'
        }}>
          {name.split(' ').map(n => n[0]).join('')}
        </div>
      )}
    </div>
    <div style={{ padding: '16px', textAlign: 'center' }}>
      <h3 style={{
        fontSize: '0.95rem',
        fontWeight: '600',
        color: '#1a1a2e',
        margin: 0
      }}>
        {name}
      </h3>
    </div>
  </div>
);

function WinnersTwo() {
  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          May 5, 2024
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2024 IRO Finalists
        </h2>
        <p style={{ fontSize: '1.2rem', color: '#1a1a2e', fontWeight: '600', marginBottom: '16px' }}>
          International Research Olympiad Finalists Announced.
        </p>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', marginBottom: '16px' }}>
          <strong>Congratulations to the finalists of the 2024 International Research Olympiad.</strong> After several stages of evaluation, the top 15 scorers have been announced as finalists.
        </p>
      </div>

      {/* Quote Card */}
      <div style={{
        background: '#f8f9fa',
        borderRadius: '16px',
        padding: '32px',
        marginBottom: '40px',
        borderLeft: '4px solid #004d99'
      }}>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '16px' }}>
          "We stand committed to making this community into a close, innovative, welcoming, and supportive society around student research aspirations. On behalf of the trustees and advisors of the 2024 International Research Olympiad, I am pleased to announce that you have been selected as a finalist in this competition. It started at over 1,000 individuals, and after several rounds of rigorous evaluation, your research abilities stood out as among the best in the world."
        </p>
        <p style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic', marginBottom: '16px' }}>
          "As someone who was involved in the final selection process based on the Oral Examination and other test scores, I can confidently say that your oral presentation was truly impressive, and it is clear that you have put a tremendous amount of effort and skill into your work. Each and every one of you brought a unique flavor to research— a skill that our scientific Board of Advisors encouraged us to seek out through this contest."
        </p>
        <p style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic', marginBottom: '16px' }}>
          "You will each receive a personalized email from a member of the IRO Director or Executive team who will guide you through the finalist process — a 1:1 line of reliable, personal communication. This individual will provide more details about your selection and the exciting next steps."
        </p>
        <p style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic', marginBottom: '16px' }}>
          "Personally, I want to take this moment to congratulate you on this achievement. As a current student who has greatly benefited from research and STEM competitions, I genuinely understand the hard work, dedication, and sacrifice that goes into achieving such a high level of success. You should all be proud of yourselves for making it this far—and be prepared to have your ambitions and accomplishments skyrocket in the near future."
        </p>
        <p style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic', marginBottom: '16px' }}>
          "The IRO finals experience has been meticulously crafted by myself and a team—a team that has extensive experience with science competitions—to optimize for the most fun and rewarding experience possible—along with the prestige that comes with placing in an international-level competition with over a thousand entries in its first year. Our goal is to make this the most memorable research event you'll ever attend."
        </p>
        <p style={{ fontSize: '0.95rem', color: '#1a1a2e', fontWeight: '600', margin: 0 }}>
          — Rishab Jain, President & Chair of Student Board of Advisors
        </p>
      </div>

      {/* Description */}
      <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', marginBottom: '50px', textAlign: 'center', maxWidth: '800px', margin: '0 auto 50px auto' }}>
        The International Research Olympiad is a platform that strives to create and promote research culture among high school students. This is done by providing a variety of services, tools, and support that aim to streamline the research process. The IRO seeks to give students the opportunity to develop their research proficiency, learn new methodologies, and collaborate at an international scale.
      </p>

      {/* Finalists Grid */}
      <div style={{ marginBottom: '30px' }}>
        <h3 style={{
          fontSize: '1.3rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '24px'
        }}>
          Meet the Finalists
        </h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
          gap: '20px'
        }}>
          {finalists.map((finalist) => (
            <FinalistCard key={finalist.id} image={finalist.image} name={finalist.name} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default WinnersTwo
